import { BandInfo } from '@photosi/expo-photosi-sdk/build/PrintUtils';
import { observer } from 'mobx-react-lite';
import { DEFAULT_SUGGESTED_BAND } from '../../ModalConfigurationSteps.constants';
import { ConfigurationStepId } from 'src/helpers/configurationSteps.helper';
import { StepCard } from '../StepCard';
import { StepCardProps } from '../StepCard.types';

export const BandCards = observer((props: StepCardProps<BandInfo>) => {
  const Component = StepCard<BandInfo>;
  return (
    <Component
      {...props}
      getIsSuggestedCard={card => card.code === DEFAULT_SUGGESTED_BAND}
      configurationStepId={ConfigurationStepId.BAND}
    />
  );
});
